import {
  CHANGE_REVISION,
  SUBMIT_APPROVAL,
  FETCH_REVISIONS,
  FETCH_REVISIONS_START,
  FETCH_REVISIONS_SUCCESS,
  FETCH_REVISIONS_ERROR,
  FETCH_APPROVALS,
  FETCH_APPROVALS_START,
  FETCH_APPROVALS_SUCCESS,
  FETCH_APPROVALS_ERROR,
  POST_APPROVALS,
  POST_APPROVALS_START,
  POST_APPROVALS_SUCCESS,
  POST_APPROVALS_ERROR,
  FETCH_PROJECT,
  FETCH_PROJECT_START,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_ERROR,
  UPDATE_PROJECT,
  UPDATE_REVISIONS,
  UPDATE_CURRENT_REVISION,
  CLEAR_PROJECT,
  CLEAR_REVISIONS,
  CLEAR_CURRENT_REVISION,
  GREENLIGHT_STATES,
  UPDATE_DIALOG_ACTIVE,
  ON_DIALOG_SUBMIT,
  ON_DIALOG_CANCEL,
  UPDATE_ACTION_TYPE,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const onDialogSubmit = () => ({ type: ON_DIALOG_SUBMIT })
const onDialogCancel = () => ({ type: ON_DIALOG_CANCEL })
const updateDialogActive = (active) => ({ type: UPDATE_DIALOG_ACTIVE, active })
const clearProject = () => ({ type: CLEAR_PROJECT })
const clearRevisions = () => ({ type: CLEAR_REVISIONS })
const clearCurrentRevision = () => ({ type: CLEAR_CURRENT_REVISION })
const changeRevision = (value) => ({ type: CHANGE_REVISION, value })
const submitApproval = (value) => ({ type: SUBMIT_APPROVAL, value })
const acceptApproval = () => ({ type: SUBMIT_APPROVAL, value: GREENLIGHT_STATES.APPROVED })
const rejectApproval = () => ({ type: SUBMIT_APPROVAL, value: GREENLIGHT_STATES.REJECTED })
const updateRevisions = (revisions) => ({ type: UPDATE_REVISIONS, revisions })
const updateCurrentRevision = (revision) => ({ type: UPDATE_CURRENT_REVISION, revision })
const updateProject = (revision, project) => ({ type: UPDATE_PROJECT, revision, project })
const updateActionType = (actionType) => ({ type: UPDATE_ACTION_TYPE, actionType })

const fetchRevisions = (projectId) => ({ type: FETCH_REVISIONS, projectId })
const fetchRevisionsStart = () => ({ type: FETCH_REVISIONS_START })
const fetchRevisionsSuccess = (data) => ({ type: FETCH_REVISIONS_SUCCESS, data })
const fetchRevisionsError = (error) => ({ type: FETCH_REVISIONS_ERROR, error })
const startFetchRevisions = buildAsyncAction(
  FETCH_REVISIONS,
  FETCH_REVISIONS_START,
  [FETCH_REVISIONS_SUCCESS, FETCH_REVISIONS_ERROR]
)

const fetchProject = (projectId, revision, categoryName) => ({
  type:
  FETCH_PROJECT,
  projectId,
  revision,
  categoryName
})
const fetchProjectStart = () => ({ type: FETCH_PROJECT_START })
const fetchProjectSuccess = (data) => ({ type: FETCH_PROJECT_SUCCESS, data })
const fetchProjectError = (error) => ({ type: FETCH_PROJECT_ERROR, error })
const startFetchProject = buildAsyncAction(
  FETCH_PROJECT,
  FETCH_PROJECT_START,
  [FETCH_PROJECT_SUCCESS, FETCH_PROJECT_ERROR]
)

const fetchApprovals = (projectId) => ({ type: FETCH_APPROVALS, projectId })
const fetchApprovalsStart = () => ({ type: FETCH_APPROVALS_START })
const fetchApprovalsSuccess = () => ({ type: FETCH_APPROVALS_SUCCESS })
const fetchApprovalsError = (error) => ({ type: FETCH_APPROVALS_ERROR, error })
const startFetchApprovals = buildAsyncAction(
  FETCH_APPROVALS,
  FETCH_APPROVALS_START,
  [FETCH_APPROVALS_SUCCESS, FETCH_APPROVALS_ERROR]
)

const postApprovals = (projectId, revision, state) => ({ type: POST_APPROVALS, projectId, revision, state })
const postApprovalsStart = () => ({ type: POST_APPROVALS_START })
const postApprovalsSuccess = () => ({ type: POST_APPROVALS_SUCCESS })
const postApprovalsError = (error) => ({ type: POST_APPROVALS_ERROR, error })
const startPostApprovals = buildAsyncAction(
  POST_APPROVALS,
  POST_APPROVALS_START,
  [POST_APPROVALS_ERROR, POST_APPROVALS_SUCCESS]
)

export {
  changeRevision,
  submitApproval,
  fetchRevisions,
  fetchRevisionsStart,
  fetchRevisionsSuccess,
  fetchRevisionsError,
  fetchApprovals,
  fetchApprovalsStart,
  fetchApprovalsSuccess,
  fetchApprovalsError,
  postApprovals,
  postApprovalsStart,
  postApprovalsSuccess,
  postApprovalsError,
  fetchProject,
  fetchProjectStart,
  fetchProjectSuccess,
  fetchProjectError,
  startFetchProject,
  startFetchRevisions,
  startFetchApprovals,
  startPostApprovals,
  updateProject,
  updateRevisions,
  updateCurrentRevision,
  clearProject,
  clearRevisions,
  clearCurrentRevision,
  acceptApproval,
  rejectApproval,
  onDialogSubmit,
  onDialogCancel,
  updateDialogActive,
  updateActionType,
}
